import { c as _c } from "react/compiler-runtime";
import { ErrorResponseInterface } from '@systemeio/util';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { baseFetcher } from 'shared/utils/http-client';
export interface UseApplePayInterface {
  badRequestHandler?: (e: ErrorResponseInterface) => void;
}
export interface UseApplePayDomains {
  shouldFetch?: boolean;
}
export type ConnectApplePayDomainData = {
  hostName: string;
};
export type ApplePayDomain = {
  host_name: string;
  id: number;
  enabled: boolean;
};
export const useApplePayDomains = t0 => {
  const $ = _c(4);
  const {
    shouldFetch
  } = t0;
  const {
    data,
    mutate,
    isLoading
  } = useControlledSwr("/api/dashboard/stripe/apple-pay/domains/show", baseFetcher, undefined, shouldFetch);
  let t1;
  if ($[0] !== data || $[1] !== isLoading || $[2] !== mutate) {
    t1 = {
      domainList: data,
      mutate,
      isLoading
    };
    $[0] = data;
    $[1] = isLoading;
    $[2] = mutate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export const useApplePayActions = t0 => {
  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    badRequestHandler
  } = t1;
  let t2;
  if ($[2] !== badRequestHandler) {
    t2 = {
      method: RequestMethodsEnum.post,
      badRequestHandler
    };
    $[2] = badRequestHandler;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    fetcher
  } = useFetch(t2);
  let t3;
  if ($[4] !== badRequestHandler) {
    t3 = {
      method: RequestMethodsEnum.delete,
      badRequestHandler
    };
    $[4] = badRequestHandler;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t3);
  let t4;
  if ($[6] !== fetcher) {
    t4 = data => fetcher("/api/dashboard/stripe/apple-pay/domain", data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    $[6] = fetcher;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const connectDomain = t4;
  let t5;
  if ($[8] !== deleteFetcher) {
    t5 = id => deleteFetcher(`/api/dashboard/stripe/apple-pay/domains/${id}`);
    $[8] = deleteFetcher;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const disconnectDomain = t5;
  let t6;
  if ($[10] !== connectDomain || $[11] !== disconnectDomain) {
    t6 = {
      connectDomain,
      disconnectDomain
    };
    $[10] = connectDomain;
    $[11] = disconnectDomain;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};